// extracted by mini-css-extract-plugin
export default {"bgPicked":"components_bgPicked__LfrqF","bgSelected":"components_bgSelected__95iNu"};